import ServicePlan from "./servicePlan";

const Subscription = class {
    constructor(object) {
        if (object === undefined || object === null) {
            this.id = null
            this.createdAt = null
            this.goodThru = null
            this.documents = null
            this.plan = null
            this.planName = null
            this.kind = null
            this.limits = null
            this.quotas = null
            this.active = null;
            this.status = null;
            this.remainingDays = null;
        } else {
            this.id = object.id || null
            this.documents = object.documents
            this.plan = new ServicePlan(object.plan)
            // Nombre visible del plan: lo manda el backend (snapshots plan=null lo derivan del
            // Subscription/PlanVersion o del kind); fallback al nombre del ServicePlan legacy.
            this.planName = object.planName || (this.plan && this.plan.name) || null
            this.kind = object.kind || null
            this.limits = object.limits || null
            // Lo que queda por dimensión (-1 = sin tope); lo ajusta la consola (H42).
            this.quotas = object.quotas || null
            this.status = object.status || null
            this.remainingDays = object.remainingDays;

            if (object.createdAt !== undefined) {
                const components = object.createdAt.split("-");
                const month = parseInt(components[1], 10) - 1;
                const createdAt = new Date(components[0], month, components[2]);
                const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',};
                const createdAtStr = createdAt.toLocaleDateString('es-EC', options);
                this.createdAt = createdAtStr.charAt(0).toUpperCase() + createdAtStr.slice(1);
            } else { this.createdAt = "-" }

            if (object.goodThru !== undefined) {
                const components = object.goodThru.split("-");
                const month = parseInt(components[1], 10) - 1;
                const goodThru = new Date(components[0], month, components[2]);
                const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long',};
                const goodThruStr = goodThru.toLocaleDateString('es-EC', options);
                this.goodThru = goodThruStr.charAt(0).toUpperCase() + goodThruStr.slice(1);
            } else { this.goodThru = "-" }
        }
    }

    // Documentos ilimitados = el snapshot de límites marca `documentos: null` (centinela).
    // Reemplaza al viejo chequeo `plan.name === 'Empresarial'`, que rompía con los
    // snapshots nuevos (plan = null) y no reflejaba los límites reales del plan.
    get unlimitedDocs() {
        return !!(this.limits && this.limits.documentos === null)
    }

    // Etiqueta de un límite del plan (asignación original): el número, o `unlimitedText`
    // cuando es null (ilimitado). Fuente: el snapshot `limits` de la suscripción.
    limitLabel(key, unlimitedText) {
        const v = this.limits ? this.limits[key] : undefined
        if (v === null || v === undefined) return unlimitedText || "Ilimitados"
        return v
    }

    // «Quedan N» de una dimensión, o null si no hay contador o no tiene tope (H42).
    // `documentos` sale de `documents`; el resto, de `quotas`.
    remainingLabel(key) {
        const v = key === 'documentos' ? this.documents : (this.quotas ? this.quotas[key] : null)
        if (v === null || v === undefined || v < 0) return null
        return `Quedan ${v}`
    }

    // Período de prueba: toda alta nace como trial de 14 días (se paga luego para activar).
    get isTrial() {
        return this.kind === "trial"
    }

    // «Renovar» está siempre a mano salvo en la prueba, que tiene «Activar mi plan» (H43).
    // Antes solo aparecía con un aviso de vencimiento o de pocos documentos.
    get canRenew() {
        return !this.isTrial
    }

    // Vencida: por fecha, o porque la consola la marcó «Expirada» sin tocar la fecha (H41).
    // Facturar ya lo respetaba; la página solo miraba remainingDays.
    get isExpired() {
        return this.status === "EXPIRED" || (this.remainingDays !== null && this.remainingDays !== undefined && this.remainingDays < 0)
    }

    get currentStatusBadgeColor() {
        if (this.status == "ACTIVE") { return "green" }
        if (this.status == "SUSPENDED") { return "yellow" }
        if (this.status == "EXPIRED") { return "red" }
        if (this.status == "NOEDOC") { return "red" }
        return "green" // UNUSED
    }

    get currentStatus() {
        if (this.status == "ACTIVE") { return "ACTIVA" }
        if (this.status == "SUSPENDED") { return "SUSPENDIDA" }
        if (this.status == "EXPIRED") { return "EXPIRADA" }
        if (this.status == "NOEDOC") { return "SIN DOCUMENTOS" }
        return "SIN EMPEZAR" // UNUSED
    }
}

export default Subscription;